import React, { useCallback } from "react";
import { connect } from "react-redux";

import Route from "@mapmycustomers/shared/types/entity/Route";

import { RootState } from "@app/store/rootReducer";
import { SavedLocationSelectSurface } from "@app/util/analytic/savedLocationsAnalytics";

import CreateRoutePureModal from "./CreateRoutePureModal";
import { isCreating } from "./store";
import { createRoute, CreateRouteFormPayload, hideCreateRouteModal } from "./store/actions";

export interface CreateRouteModalProps {
  createOnly?: boolean;
  onCreated?: (route: Route) => void;
  routes: Route[];
}

const CreateRouteModal = ({
  createOnly,
  createRoute,
  creating,
  hideCreateRouteModal,
  onCreated,
  routes,
}: CreateRouteModalProps & ReturnType<typeof mapStateToProps> & typeof mapDispatchToProps) => {
  const handleHideClick = useCallback(() => hideCreateRouteModal(), [hideCreateRouteModal]);

  const handleCreate = useCallback(
    (payload: CreateRouteFormPayload) =>
      createRoute({
        callback: (route) => onCreated?.(route),
        route: payload,
      }),
    [createRoute, onCreated]
  );

  return (
    <CreateRoutePureModal
      createOnly={createOnly}
      creating={creating}
      onCreate={handleCreate}
      onHide={handleHideClick}
      routes={routes}
      surface={SavedLocationSelectSurface.CREATE_ROUTE}
    />
  );
};

const mapStateToProps = (state: RootState) => ({
  creating: isCreating(state),
});

const mapDispatchToProps = {
  createRoute: createRoute.request,
  hideCreateRouteModal,
};

export default connect(mapStateToProps, mapDispatchToProps)(CreateRouteModal);
